// seoConstants.js
'use strict';

export const alternateDomainMap = {
  default: 'swag.live',
  'ms-my': 'my01.swag.live',
};
